export const brandColors = {
  panelGray: "#D7DAE3",
  cdlRed: "#D2152C",
  cdlDarkBlue: "#0E537B",
  goGreen: "#00C058",
  goGreenHover: "#00A94D",
  settingYellow: "#FFBF00",
  cdlLightBlue: "#1982C4",
};
